import {OrderErrorCodes} from './OrderErrorCodes';
import Vue from 'vue';
import i18n from '../i18n';

export class ApiErrorHandler {
  public handle(error: Error): string {
    try {
      const errorCode = this.getErrorCode(error);
      if (errorCode) {
        const message = this.getTranslatedErrorMessage(errorCode);
        Vue.toasted.show(
          `${i18n.t('titles.error')} ${errorCode}: ${message}`,
          {duration: 10000, position: 'bottom-right'},
        );
      } else {
        Vue.toasted.show(
          `${i18n.t('titles.error')} ${this.getTranslatedErrorMessage(0)}`,
          {duration: 10000, position: 'bottom-right'},
        );
        throw new Error('Could not read error code.');
      }
    } catch (e) {
      console.error(e);
      Vue.toasted.show(
        error.message,
        {duration: 10000, position: 'bottom-right'},
      );
    }
    return '';
  }

  public getErrorCode(error: Error): number | null {
    try {
      const jsonMessage = JSON.parse(error.message);
      if (jsonMessage.error) {
        let errorCode = Number.parseInt(jsonMessage.error, 10);
        if (Number.isNaN(errorCode) && jsonMessage.error.error) {
          errorCode = Number.parseInt(jsonMessage.error.error, 10);
        }
        if (OrderErrorCodes.isValidErrorCode(errorCode)) {
          return errorCode;
        }
      }
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  public getErrorData(error: Error): any | null {
    try {
      const jsonMessage = JSON.parse(error.message);
      return jsonMessage.data ? jsonMessage.data : null;
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  private getTranslatedErrorMessage(errorCode: number): string {
    return i18n.t(`errorCodes.${errorCode}`) as string;
  }
}
